import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { variant } from 'styled-system';
import Link from '@material-ui/core/Link';

const ButtonNormal = styled('button')(
  {
    minWidth: '160px',
    maxWidth: '384px',
    padding: '0 20px',
    height: '48px',
    width:'100%',
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '31px',
    textAlign: 'center',
    fontStyle: 'normal',
    lineHeight: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    appearance: 'none',
    outline: 'none',
  },
  variant({
    variants: {
      primary: {
        color: '#ffffff',
        border: 'none',
        backgroundColor: '#013957', //$Blue1
        '&:disabled': {
          opacity: '0.6',
          backgroundColor: '#57a4cc', //#Blue9
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#106c9d', //#Blue5
          textDecoration: 'none'
        },
        '&:focus': {
          backgroundColor: '#013957', //#Blue1
        },
      },
      primarySolidOutlined: {
        color: '#013957', //#Blue4
        backgroundColor: '#ffffff',
        border: 'solid 1px #10587f',

        '&:disabled': {
          opacity: '0.6',
          //backgroundColor: '#478eb5', //#Blue6
          backgroundColor: '#57a4cc', //#Blue9
          cursor: 'not-allowed',
        },
        '&:hover': {
          border: 'none', //#Blue4
          color: '#ffffff', //#Blue4
          backgroundColor: '#35b9b6',
        },
        '&:focus': {
          color: '#013957', //#Blue4
          backgroundColor: '#ffffff',
          border: 'solid 3px #10587f',
        },
      },
      primaryOutlined: {
        color: '#478eb5', //$Blue6
        border: 'solid 1px #478eb5', //$Blue6
        backgroundColor: '#ffffff',
        '&:disabled': {
          border: 'solid 1px #478eb5', //$Blue6
          opacity: '0.6',
          cursor: 'not-allowed',
        },
        '&:hover': {
          border: 'solid 1px #10587f', //#Blue4
          color: '#10587f', //#Blue4
        },
        '&:focus': {
          border: 'solid 1px #013957', //#Blue1
          color: '#013957', //#Blue1
        },
      },
      secondary: {
        color: '#ffffff',
        border: 'none',
        backgroundColor: '#7cd4d2', //$
        '&:disabled': {
          opacity: '0.6',
          backgroundColor: '#7cd4d2', //#
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#1daeab', //#
        },
        '&:focus': {
          backgroundColor: '#35b9b6', //#Menta
        },
      },
      secondaryOutlined: {
        color: '#35b9b6', //Menta
        border: '1px solid #35b9b6',
        backgroundColor: '#ffffff', 
        '&:disabled': {
          opacity: '0.6',
          backgroundColor: '#ffffff', 
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#35b9b6',
          color: '#ffffff',
        },
        '&:focus': {
          backgroundColor: '#ffffff', 
          color: '#35b9b6',
        },
      },
    },
  })
);

const Button = props => (
  <ThemeProvider theme={{}}>
      <ButtonNormal {...props}>{props.children}</ButtonNormal>
  </ThemeProvider>
);

export default Button;
